import { descartarOrgDaAba } from '@/contexts/orgDaAba';

/**
 * Utilitário para limpar o cache da aplicação
 * Útil para testar a splash screen em desenvolvimento e resolver problemas de carregamento
 */
const clearAppCache = () => {
  try {
    // Limpar cache de inicialização
    localStorage.removeItem('app_last_initialization');
    localStorage.removeItem('app_last_render');
    localStorage.removeItem('app_cache_version');
    
    // Limpar organização atual (a guardada e a só desta aba)
    localStorage.removeItem('current_org_id');
    descartarOrgDaAba();
    
    // Limpar filtros persistentes
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('filters_')) {
        localStorage.removeItem(key);
      }
    });
    
    // Limpar sessionStorage
    Object.keys(sessionStorage || {}).forEach((key) => {
      if (key.startsWith('sequence_form_') || key.startsWith('lead_form_')) {
        sessionStorage.removeItem(key);
      }
    });
    
    console.log('✅ Cache da aplicação limpo!');
    console.log('💡 Se o problema persistir, use clearAllCache() para limpar também a autenticação.');
  } catch (error) {
    console.error('Erro ao limpar cache:', error);
  }
};

/**
 * Função para limpar TUDO (incluindo autenticação)
 * ATENÇÃO: Isso vai deslogar o usuário!
 */
const clearAllCache = () => {
  clearAppCache();
  try {
    // Limpar cache do Supabase Auth
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
        localStorage.removeItem(key);
      }
    });
    
    // Limpar sessionStorage do Supabase
    Object.keys(sessionStorage || {}).forEach((key) => {
      if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
        sessionStorage.removeItem(key);
      }
    });
    
    console.log('✅ Cache completo limpo (incluindo autenticação)');
    console.log('⚠️ Você será deslogado. Faça login novamente.');
  } catch (error) {
    console.error('Erro ao limpar cache completo:', error);
  }
};

// Disponibilizar globalmente para uso no console
if (typeof window !== 'undefined') {
  (window as any).clearAppCache = clearAppCache;
  (window as any).clearAllCache = clearAllCache;
}

export {};
